module.exports = __webpack_public_path__ + "img/logo_comprovei_black.79aa20f7.png";